import { Col, Form, Input, Row, Select, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx'
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
// import objectHandle from '../../../utils/baseLib/objectHandle';

//布局
const layout = {
    // labelCol: { span: 4 },
    // wrapperCol: { span: 4 },
};

const EditComponent = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };
    /** 后端数据wmService */
    let wmService: any = "";

    const [assetSubcategoryData, setAssetSubcategoryData] = useState<any>();
    const [productData, setProductData] = useState<any>();
    const [productUnitData, setProductUnitData] = useState<any>();

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            ref.current.row.then(async (res: any) => {
                if (res) {
                    if (res.success === true) {
                        const { productId } = res.data;
                        fetchApi.GET(wmService, {
                            apiId: 'sys_product',
                            apiExtend: 'showSingle',
                            apiVariable: productId
                        }).then(res => {
                            if (res.success) {
                                setProductData(res.data);
                            }
                        });
                    }
                }
            })
        }
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: 'assetSubcategory',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setAssetSubcategoryData(res.data);
                }
            });
            fetchApi.GET(wmService, {
                apiId: 'sys_productUnit',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setProductUnitData(res.data);
                }
            });
        }
        fetchData()
    }, [])

    /**
     * 已选择
     * @param eObj 
     */
    const onProductIdSelect = (eObj: any) => {
        // const aliasName = form.getFieldValue('aliasName');
        // if (objectHandle.isEmpty(aliasName) === true) {
        if (eObj) {
            const { children } = eObj;
            form.setFieldValue('aliasName', children);
        }
        // }
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'assetStatement',
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '资产表'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                width={800}
                closable={false}
                maskClosable={false}
            >
                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            // handleOk(e)
                        }
                    }}>
                    <Row gutter={[8, 0]}>
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="识别号"
                                name="internalId">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="资产子类别"
                                name="assetSubcategoryId"
                                rules={[{ required: true, message: '请选择资产子类别!' }]}>
                                <Select
                                    placeholder="资产子类别"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {/* {getList.general(aliVoiceData, 'voiceName')} */}
                                    {getList.generalEx(assetSubcategoryData, { itemName: 'subcategoryName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="资产"
                                name="productId"
                                tooltip="输入名称或专属id查找资产"
                                rules={[{ required: true, message: '请选择资产!' }]}>
                                <Select
                                    showSearch={true}
                                    onSearch={(e) => getList.search('sys_product', setProductData, e)}
                                    onSelect={(_e, eObj) => onProductIdSelect(eObj)}
                                    placeholder="资产"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) => {
                                        return true;
                                    }}>
                                    {/* {getList.general(aliVoiceData, 'voiceName')} */}
                                    {getList.generalEx(productData, { itemName: 'productName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="别名"
                                name="aliasName"
                                tooltip="资产名称"
                                rules={[{ required: true, message: '请输入别名!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="规格"
                                name="specs">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="单位"
                                name="productUnitId"
                                rules={[{ required: true, message: '请选择单位!' }]}>
                                <Select
                                    showSearch={true}
                                    placeholder="单位"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {/* {getList.general(aliVoiceData, 'voiceName')} */}
                                    {getList.generalEx(productUnitData, { itemName: 'productUnitName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <Input type={"number"} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default EditComponent;